
import { WorldCountry } from '../types';

// Expansión de países nórdicos
export const nordicCountriesExpanded: WorldCountry[] = [
  // Suecia expandida
  {
    code: 'SE',
    name: 'Sweden',
    slug: 'sweden',
    population: 10500000,
    topCities: [
      { name: 'Stockholm', slug: 'stockholm', population: 975551 },
      { name: 'Gothenburg', slug: 'gothenburg', population: 579281 },
      { name: 'Malmö', slug: 'malmo', population: 350647 },
      { name: 'Uppsala', slug: 'uppsala', population: 230767 },
      { name: 'Sollentuna', slug: 'sollentuna', population: 73314 },
      { name: 'Västerås', slug: 'vasteras', population: 127734 },
      { name: 'Örebro', slug: 'orebro', population: 126009 },
      { name: 'Linköping', slug: 'linkoping', population: 164616 },
      { name: 'Helsingborg', slug: 'helsingborg', population: 149280 },
      { name: 'Jönköping', slug: 'jonkoping', population: 141081 },
      { name: 'Norrköping', slug: 'norrkoping', population: 143171 },
      { name: 'Lund', slug: 'lund', population: 94417 },
      { name: 'Umeå', slug: 'umea', population: 89081 },
      { name: 'Gävle', slug: 'gavle', population: 102418 },
      { name: 'Borås', slug: 'boras', population: 113519 },
      { name: 'Södertälje', slug: 'sodertalje', population: 99270 },
      { name: 'Eskilstuna', slug: 'eskilstuna', population: 107806 },
      { name: 'Halmstad', slug: 'halmstad', population: 105120 },
      { name: 'Växjö', slug: 'vaxjo', population: 95995 },
      { name: 'Karlstad', slug: 'karlstad', population: 95403 },
      { name: 'Sundsvall', slug: 'sundsvall', population: 58807 },
      { name: 'Trollhättan', slug: 'trollhattan', population: 59058 },
      { name: 'Östersund', slug: 'ostersund', population: 49806 },
      { name: 'Borlänge', slug: 'borlange', population: 51604 },
      { name: 'Falun', slug: 'falun', population: 37291 },
      { name: 'Skövde', slug: 'skovde', population: 40437 },
      { name: 'Kristianstad', slug: 'kristianstad', population: 40145 },
      { name: 'Karlskrona', slug: 'karlskrona', population: 66675 },
      { name: 'Skellefteå', slug: 'skelleftea', population: 32775 },
      { name: 'Uddevalla', slug: 'uddevalla', population: 35303 },
      { name: 'Motala', slug: 'motala', population: 29859 },
      { name: 'Sandviken', slug: 'sandviken', population: 25631 },
      { name: 'Lidköping', slug: 'lidkoping', population: 25644 },
      { name: 'Landskrona', slug: 'landskrona', population: 46275 },
      { name: 'Örnsköldsvik', slug: 'ornskoldsvik', population: 32953 },
      { name: 'Nyköping', slug: 'nykoping', population: 32759 },
      { name: 'Katrineholm', slug: 'katrineholm', population: 24079 },
      { name: 'Trelleborg', slug: 'trelleborg', population: 46619 },
      { name: 'Kiruna', slug: 'kiruna', population: 18154 },
      { name: 'Ängelholm', slug: 'angelholm', population: 25490 },
      { name: 'Kalmar', slug: 'kalmar', population: 41388 },
      { name: 'Karlshamn', slug: 'karlshamn', population: 19843 },
      { name: 'Värnamo', slug: 'varnamo', population: 19680 },
      { name: 'Piteå', slug: 'pitea', population: 23067 },
      { name: 'Sandviken', slug: 'sandviken-center', population: 39259 },
      { name: 'Mariestad', slug: 'mariestad', population: 15448 },
      { name: 'Lidingö', slug: 'lidingo', population: 47747 },
      { name: 'Solna', slug: 'solna', population: 81156 },
      { name: 'Danderyd', slug: 'danderyd', population: 33262 },
      { name: 'Nacka', slug: 'nacka', population: 106166 },
      { name: 'Sundbyberg', slug: 'sundbyberg', population: 51447 },
      { name: 'Haninge', slug: 'haninge', population: 92925 },
      { name: 'Tyresö', slug: 'tyreso', population: 48339 },
      { name: 'Upplands Väsby', slug: 'upplands-vasby', population: 46672 },
      { name: 'Vallentuna', slug: 'vallentuna', population: 34470 },
      { name: 'Österåker', slug: 'osteraker', population: 45185 },
      { name: 'Täby', slug: 'taby', population: 71566 },
      { name: 'Vaxholm', slug: 'vaxholm', population: 12236 },
      { name: 'Norrtälje', slug: 'norrtalje', population: 18429 },
      { name: 'Sigtuna', slug: 'sigtuna', population: 48804 },
      { name: 'Nykvarn', slug: 'nykvarn', population: 10868 },
      { name: 'Salem', slug: 'salem', population: 16958 },
      { name: 'Botkyrka', slug: 'botkyrka', population: 92998 },
      { name: 'Huddinge', slug: 'huddinge', population: 111722 },
      { name: 'Järfälla', slug: 'jarfalla', population: 79706 },
      { name: 'Ekerö', slug: 'ekero', population: 28355 },
      { name: 'Upplands-Bro', slug: 'upplands-bro', population: 28466 },
      { name: 'Norberg', slug: 'norberg', population: 5731 },
      { name: 'Skinnskatteberg', slug: 'skinnskatteberg', population: 4413 },
      { name: 'Surahammar', slug: 'surahammar', population: 10141 },
      { name: 'Kungsör', slug: 'kungsor', population: 8265 },
      { name: 'Hallstahammar', slug: 'hallstahammar', population: 16454 },
      { name: 'Köping', slug: 'koping', population: 17358 },
      { name: 'Arboga', slug: 'arboga', population: 10925 },
      { name: 'Vansbro', slug: 'vansbro', population: 6750 },
      { name: 'Malung-Sälen', slug: 'malung-salen', population: 9958 },
      { name: 'Gagnef', slug: 'gagnef', population: 10235 },
      { name: 'Leksand', slug: 'leksand', population: 15893 },
      { name: 'Rättvik', slug: 'rattvik', population: 10794 },
      { name: 'Orsa', slug: 'orsa', population: 6890 },
      { name: 'Älvdalen', slug: 'alvdalen', population: 7030 },
      { name: 'Smedjebacken', slug: 'smedjebacken', population: 10618 },
      { name: 'Mora', slug: 'mora', population: 20473 },
      { name: 'Ludvika', slug: 'ludvika', population: 26644 },
      { name: 'Avesta', slug: 'avesta', population: 23072 },
      { name: 'Hedemora', slug: 'hedemora', population: 15421 },
      { name: 'Säter', slug: 'sater', population: 11252 },
      { name: 'Sandviken', slug: 'sandviken-dalarna', population: 39259 },
      { name: 'Hofors', slug: 'hofors', population: 9707 },
      { name: 'Storuman', slug: 'storuman', population: 5974 },
      { name: 'Sorsele', slug: 'sorsele', population: 2521 },
      { name: 'Malå', slug: 'mala', population: 3124 },
      { name: 'Norsjö', slug: 'norsjo', population: 4079 },
      { name: 'Skellefteå', slug: 'skelleftea-center', population: 33423 },
      { name: 'Lycksele', slug: 'lycksele', population: 8513 },
      { name: 'Åsele', slug: 'asele', population: 2794 },
      { name: 'Vilhelmina', slug: 'vilhelmina', population: 6792 },
      { name: 'Dorotea', slug: 'dorotea', population: 2498 },
      { name: 'Vännäs', slug: 'vannas', population: 8885 },
      { name: 'Vindeln', slug: 'vindeln', population: 5348 },
      { name: 'Robertsfors', slug: 'robertsfors', population: 6769 },
      { name: 'Nordmaling', slug: 'nordmaling', population: 7096 },
      { name: 'Bjurholm', slug: 'bjurholm', population: 2387 },
      { name: 'Umeå', slug: 'umea-center', population: 130224 },
      { name: 'Kramfors', slug: 'kramfors', population: 18595 },
      { name: 'Härnösand', slug: 'harnosand', population: 18003 },
      { name: 'Sollefteå', slug: 'solleftea', population: 19372 },
      { name: 'Ragunda', slug: 'ragunda', population: 5259 },
      { name: 'Bräcke', slug: 'bracke', population: 6398 },
      { name: 'Krokom', slug: 'krokom', population: 15021 },
      { name: 'Strömsund', slug: 'stromsund', population: 11635 },
      { name: 'Åre', slug: 'are', population: 11685 },
      { name: 'Berg', slug: 'berg', population: 7122 },
      { name: 'Härjedalen', slug: 'harjedalen', population: 10135 }
    ]
  },
  
  // Noruega expandida
  {
    code: 'NO',
    name: 'Norway',
    slug: 'norway',
    population: 5400000,
    topCities: [
      { name: 'Oslo', slug: 'oslo', population: 697010 },
      { name: 'Bergen', slug: 'bergen', population: 285911 },
      { name: 'Trondheim', slug: 'trondheim', population: 205332 },
      { name: 'Stavanger', slug: 'stavanger', population: 144699 },
      { name: 'Bærum', slug: 'baerum', population: 128760 },
      { name: 'Kristiansand', slug: 'kristiansand', population: 65026 },
      { name: 'Fredrikstad', slug: 'fredrikstad', population: 83159 },
      { name: 'Tromsø', slug: 'tromso', population: 76974 },
      { name: 'Sandnes', slug: 'sandnes', population: 80330 },
      { name: 'Drammen', slug: 'drammen', population: 103369 },
      { name: 'Asker', slug: 'asker', population: 93858 },
      { name: 'Lillehammer', slug: 'lillehammer', population: 28560 },
      { name: 'Halden', slug: 'halden', population: 31771 },
      { name: 'Moss', slug: 'moss', population: 50240 },
      { name: 'Bodø', slug: 'bodo', population: 52357 },
      { name: 'Molde', slug: 'molde', population: 31263 },
      { name: 'Ålesund', slug: 'alesund', population: 65545 },
      { name: 'Tønsberg', slug: 'tonsberg', population: 56293 },
      { name: 'Sandefjord', slug: 'sandefjord', population: 66975 },
      { name: 'Haugesund', slug: 'haugesund', population: 37357 },
      { name: 'Sarpsborg', slug: 'sarpsborg', population: 57595 },
      { name: 'Skien', slug: 'skien', population: 54668 },
      { name: 'Arendal', slug: 'arendal', population: 45906 },
      { name: 'Hamar', slug: 'hamar', population: 31797 },
      { name: 'Kongsberg', slug: 'kongsberg', population: 28938 },
      { name: 'Harstad', slug: 'harstad', population: 25398 },
      { name: 'Porsgrunn', slug: 'porsgrunn', population: 36770 },
      { name: 'Lørenskog', slug: 'lorenskog', population: 38758 },
      { name: 'Ullensaker', slug: 'ullensaker', population: 41204 },
      { name: 'Ski', slug: 'ski', population: 33255 },
      { name: 'Ås', slug: 'as', population: 21888 },
      { name: 'Nesodden', slug: 'nesodden', population: 20872 },
      { name: 'Oppegård', slug: 'oppegard', population: 26936 },
      { name: 'Enebakk', slug: 'enebakk', population: 11012 },
      { name: 'Rælingen', slug: 'raelingen', population: 18803 },
      { name: 'Fet', slug: 'fet', population: 11824 },
      { name: 'Skedsmo', slug: 'skedsmo', population: 55088 },
      { name: 'Gjerdrum', slug: 'gjerdrum', population: 6804 },
      { name: 'Nittedal', slug: 'nittedal', population: 24043 },
      { name: 'Lunner', slug: 'lunner', population: 9282 },
      { name: 'Jevnaker', slug: 'jevnaker', population: 6995 },
      { name: 'Nannestad', slug: 'nannestad', population: 13064 },
      { name: 'Eidsvoll', slug: 'eidsvoll', population: 24247 },
      { name: 'Hurdal', slug: 'hurdal', population: 2909 },
      { name: 'Ringerike', slug: 'ringerike', population: 30294 },
      { name: 'Hole', slug: 'hole', population: 6613 },
      { name: 'Flå', slug: 'flaa', population: 1025 },
      { name: 'Nes', slug: 'nes', population: 22666 },
      { name: 'Gol', slug: 'gol', population: 4621 },
      { name: 'Hemsedal', slug: 'hemsedal', population: 2368 },
      { name: 'Ål', slug: 'al', population: 4707 },
      { name: 'Hol', slug: 'hol', population: 4850 },
      { name: 'Sigdal', slug: 'sigdal', population: 3490 },
      { name: 'Krødsherad', slug: 'krodsherad', population: 2280 },
      { name: 'Modum', slug: 'modum', population: 14051 },
      { name: 'Øvre Eiker', slug: 'ovre-eiker', population: 19385 },
      { name: 'Nedre Eiker', slug: 'nedre-eiker', population: 25739 },
      { name: 'Lier', slug: 'lier', population: 26423 },
      { name: 'Røyken', slug: 'royken', population: 21704 },
      { name: 'Hurum', slug: 'hurum', population: 9707 },
      { name: 'Flesberg', slug: 'flesberg', population: 2634 },
      { name: 'Rollag', slug: 'rollag', population: 1299 },
      { name: 'Nore og Uvdal', slug: 'nore-og-uvdal', population: 2492 },
      { name: 'Hønefoss', slug: 'honefoss', population: 16129 },
      { name: 'Larvik', slug: 'larvik', population: 47715 },
      { name: 'Lardal', slug: 'lardal', population: 2454 },
      { name: 'Svelvik', slug: 'svelvik', population: 6539 },
      { name: 'Sande', slug: 'sande', population: 10657 },
      { name: 'Hof', slug: 'hof', population: 3301 },
      { name: 'Re', slug: 're', population: 9105 },
      { name: 'Holmestrand', slug: 'holmestrand', population: 25963 },
      { name: 'Horten', slug: 'horten', population: 27595 },
      { name: 'Færder', slug: 'faerder', population: 27778 },
      { name: 'Notodden', slug: 'notodden', population: 12626 },
      { name: 'Bø', slug: 'bo', population: 6395 },
      { name: 'Sauherad', slug: 'sauherad', population: 4320 },
      { name: 'Nome', slug: 'nome', population: 6654 },
      { name: 'Midt-Telemark', slug: 'midt-telemark', population: 2811 },
      { name: 'Tinn', slug: 'tinn', population: 5900 },
      { name: 'Hjartdal', slug: 'hjartdal', population: 1640 },
      { name: 'Seljord', slug: 'seljord', population: 2851 },
      { name: 'Kviteseid', slug: 'kviteseid', population: 2589 },
      { name: 'Nissedal', slug: 'nissedal', population: 1451 },
      { name: 'Fyresdal', slug: 'fyresdal', population: 1322 },
      { name: 'Tokke', slug: 'tokke', population: 2179 },
      { name: 'Vinje', slug: 'vinje', population: 3699 },
      { name: 'Siljan', slug: 'siljan', population: 2467 },
      { name: 'Bamble', slug: 'bamble', population: 14258 },
      { name: 'Kragerø', slug: 'kragero', population: 10586 },
      { name: 'Drangedal', slug: 'drangedal', population: 4136 },
      { name: 'Nome', slug: 'nome-telemark', population: 6654 },
      { name: 'Birkenes', slug: 'birkenes', population: 5122 },
      { name: 'Åmli', slug: 'amli', population: 1897 },
      { name: 'Iveland', slug: 'iveland', population: 1384 },
      { name: 'Evje og Hornnes', slug: 'evje-og-hornnes', population: 3612 },
      { name: 'Bygland', slug: 'bygland', population: 1239 },
      { name: 'Valle', slug: 'valle', population: 1265 },
      { name: 'Bykle', slug: 'bykle', population: 916 },
      { name: 'Vennesla', slug: 'vennesla', population: 15175 },
      { name: 'Åseral', slug: 'aseral', population: 863 },
      { name: 'Lyngdal', slug: 'lyngdal', population: 9936 },
      { name: 'Hægebostad', slug: 'haegebostad', population: 1681 },
      { name: 'Kvinesdal', slug: 'kvinesdal', population: 6011 },
      { name: 'Sirdal', slug: 'sirdal', population: 1819 },
      { name: 'Flekkefjord', slug: 'flekkefjord', population: 8890 },
      { name: 'Farsund', slug: 'farsund', population: 9364 }
    ]
  }
];
